import React, { useEffect } from "react";
import { useAssetContext } from "../../DataContext/AssetContext";

interface GranularityAggregationToggleProps {
  className?: string;
}

const GranularityAggregationToggle: React.FC<GranularityAggregationToggleProps> = ({
  className = "w-auto",
}) => {
  const { useIntervalAggregation, setUseIntervalAggregation } = useAssetContext();


  useEffect(() => {
    if (useIntervalAggregation === undefined) {
      setUseIntervalAggregation(true);
    }
  }, [useIntervalAggregation, setUseIntervalAggregation]);

  const handleToggle = () => {
    setUseIntervalAggregation(!useIntervalAggregation);
  };

  return (
    <div className={className}>
      <label className="block text-md font-medium text-gray-700 mb-1">Aggregate Hourly</label>
      <div className="flex items-center h-[38px]">
        <div
          onClick={handleToggle}
          className={`w-10 h-6 flex items-center rounded-full p-0.5 cursor-pointer transition-colors duration-300 ${
            useIntervalAggregation ? "bg-gray-500" : "bg-gray-300"
          }`}
        >
          <div
            className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 ${
              useIntervalAggregation ? "translate-x-4" : "translate-x-0"
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default GranularityAggregationToggle;
